module.exports = __webpack_public_path__ + "img/payment.9b6cf8e6.svg";